import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import ActionButton from 'components/action-button';
import Modal, { ModalContent, ModalHeading, ModalSize } from 'components/modal';
import UnstyledButton from 'components/unstyled-button';

const ButtonContainer = styled.div`
  height: 100%;
  margin-bottom: 40px;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
`;

const Button = styled(UnstyledButton)`
  height: 50px;
  width: 120px;
  text-decoration: underline;
  cursor: pointer;
`;

const CenteredParagraph = styled.p`
  text-align: center;
  font-size: 0.875rem;
`;

export interface IConfirmationModalProps {
  headingText: string;
  bodyText: string;
  onConfirm?: () => void;
  onDismiss?: () => void;
  modalAppearanceEventMessage: string;
}

// @TODO: Generalize this component. Maybe accept and render children?
export const ConfirmationModal: React.FC<IConfirmationModalProps> = ({
  modalAppearanceEventMessage,
  ...props
}) => (
  <Modal
    size={ModalSize.SMALL}
    onDismiss={props.onDismiss}
    mParticleEventData={{
      modalAppearanceEventMessage,
      modalMessage: props.bodyText,
    }}
  >
    <ConfirmationModalContent {...props} />
  </Modal>
);

export const ConfirmationModalContent: React.FC<
  Omit<IConfirmationModalProps, 'modalAppearanceEventMessage'>
> = ({ headingText, bodyText, onConfirm = () => {}, onDismiss = () => {} }) => {
  const { formatMessage } = useIntl();

  return (
    <ModalContent>
      <ModalHeading>{headingText}</ModalHeading>
      <CenteredParagraph>{bodyText}</CenteredParagraph>
      <ButtonContainer>
        <ActionButton onClick={onConfirm}>{formatMessage({ id: 'continue' })}</ActionButton>
        <Button onClick={onDismiss}>{formatMessage({ id: 'dismiss' })}</Button>
      </ButtonContainer>
    </ModalContent>
  );
};

export default ConfirmationModal;
